package one.healthium.today.ui.models

import androidx.compose.runtime.Composable
import one.healthium.base.utils.toVolumeString
import one.healthium.base.utils.toVolumeUnit
import one.healthium.loco.resolve

data class WaterIntakeUiModel(
    val dailyAmount: Float,
    val currentValue: Float,
    val isMetric: Boolean,
) {
    val progress: Float = if (dailyAmount == 0f) 0f else currentValue / dailyAmount
    val displayValue = currentValue.toVolumeString(isMetric) + " / " + dailyAmount.toVolumeString(isMetric)
    val displayValueWithUnit
        @Composable get() = displayValue + " " + isMetric.toVolumeUnit().resolve()
}
